import axios from "axios";
// import { get } from "lodash";
import { URL, USER,PASS } from './base_url'
// import {logout,refreshToken} from '../redux/actions/auth'
import Cookie from 'universal-cookie'
import { setError ,modalToggle} from "../redux/actions/general";
import { logout } from "redux/actions/auth";
const cookie=new Cookie()



export const apiCall=({method,url,data='',isLogin})=>async(dispatch)=>{
    try{
        const response=await axios({
            method:method,
            url:URL+url,
            data:data.data||"",
            auth:data.auth,
            headers:data.headers,
            timeout:1200000
        })
        return response
    }catch(error){
        let response=error.response
        if(response!==undefined){
            if(error.response.status===401){
                if(!isLogin){
                    dispatch(logout())

                }
                return response
                // window.location.assign('https://cdhx.gmlperformance.com/forum')
            }else{
                // dispatch(modalToggle({ 
                //     modal_open: true,
                //     modal_title: "",
                //     modal_component: "",
                //     modal_size:400,
                //     modal_type:'alert',
                //     modal_data:{
                //         msg:'<p>Opps, An error occurred,check your connection or please contact Support team 🙏</p>'
                //     },
                //     modal_action:'error'
                // }))
            }
        }else{
            // dispatch(modalToggle({ 
            //     modal_open: true,
            //     modal_title: "",
            //     modal_component: "",
            //     modal_size:400,
            //     modal_type:'alert',
            //     modal_data:{
            //         msg:'<p>Opps, An error occurred,check your connection or please contact Support team 🙏</p>'
            //     },
            //     modal_action:'error'
            // }))
        }
       
        return error
    }
}